import { createFileRoute, Link } from "@tanstack/react-router";
import { TRADE_HUBS, BUSINESS } from "@/lib/site-data";

const BASE_URL = "https://lehitradessaeo.com";

export const Route = createFileRoute("/hubs")({
  head: () => ({
    meta: [
      { title: `Trade Marketing Hubs | ${BUSINESS.shortName}` },
      {
        name: "description",
        content:
          "Trade-specific marketing hubs for plumbers, electricians, HVAC, and roofing contractors — every silo we run inside a contractor SEO and Google Ads program.",
      },
      { property: "og:title", content: `Trade Marketing Hubs | ${BUSINESS.shortName}` },
      {
        property: "og:description",
        content:
          "Deep, interconnected marketing playbooks for plumbers, electricians, HVAC, and roofing contractors.",
      },
      { property: "og:url", content: `${BASE_URL}/hubs` },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: `${BASE_URL}/hubs` }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "CollectionPage",
          name: "Trade Marketing Hubs",
          url: `${BASE_URL}/hubs`,
          isPartOf: { "@id": `${BASE_URL}/#website` },
          mainEntity: {
            "@type": "ItemList",
            itemListElement: TRADE_HUBS.map((h, i) => ({
              "@type": "ListItem",
              position: i + 1,
              name: h.title,
              url: `${BASE_URL}/hubs/${h.slug}`,
            })),
          },
        }),
      },
    ],
  }),
  component: HubsIndex,
});

function HubsIndex() {
  return (
    <main className="mx-auto max-w-5xl px-6 py-20">
      <p className="text-xs font-medium uppercase tracking-[0.2em] text-muted-foreground">
        Trade Marketing Hubs
      </p>
      <h1 className="mt-3 font-display text-5xl tracking-tight md:text-6xl">
        Marketing hubs, built one trade at a time
      </h1>
      <p className="mt-5 max-w-2xl text-lg text-muted-foreground">
        Each hub is a deep, interconnected playbook for a single trade — every
        silo we build (local SEO, paid, GBP, GEO) plus the city pages and blog
        playbooks tied to it.
      </p>
      <ul className="mt-12 grid gap-4 md:grid-cols-2">
        {TRADE_HUBS.map((h) => (
          <li key={h.slug}>
            <Link
              to="/hubs/$trade"
              params={{ trade: h.slug }}
              className="group block rounded-2xl border border-border bg-card p-6 transition hover:border-primary/40 hover:shadow-sm"
            >
              <div className="flex items-start justify-between">
                <div>
                  <p className="text-xs font-medium uppercase tracking-[0.2em] text-primary">
                    {h.trade}
                  </p>
                  <h2 className="mt-2 font-display text-2xl tracking-tight">{h.title}</h2>
                  <p className="mt-2 text-sm text-muted-foreground">{h.tagline}</p>
                </div>
                <span className="ml-4 text-primary transition group-hover:translate-x-1">→</span>
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </main>
  );
}